export default "__VITE_ASSET__C0vCh02D__"